module.exports = __webpack_public_path__ + "static/media/gold-logo-TRANSPARENT.87958669.PNG";